/**
 * AM.One API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A discoverable API specification file.
 */
export interface ApiSpecificationDto { 
    fileName: string;
    relativePath: string;
    type: ApiSpecificationDto.TypeEnum;
    title?: string | null;
    created?: string | null;
    lastEditedBy?: string | null;
    lastModified?: string | null;
    commitTimestamp?: string | null;
}
export namespace ApiSpecificationDto {
    export const TypeEnum = {
        OpenApi: 'OpenAPI',
        Swagger: 'Swagger',
        AsyncApi: 'AsyncAPI'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


